import { useLayoutEffect, useRef } from 'react'
import useAuthApi from '@Apis/useAuthApi';
import { useHistory, useLocation } from "react-router-dom";
import { localUser } from "@Util/utils";
import { LOGIN_ROOT_ROUTER } from "@Router/routerPath";

// /auth?t=<token> 交接頁：接住導來的綁定 token 並寫入 localUser，無 UI（return null）。
const AuthPage = () => {
    const { getCheckLocalDataApi, getLogoutApi } = useAuthApi();
    const { pathname: rootPath = '', search } = useLocation();
    const query = new URLSearchParams(search);
    const history = useHistory();
    const didAuthRef = useRef(false);

    const resetToken = async (tokenKey, nextPath) => {
        const hasLogin = await getCheckLocalDataApi();

        if (hasLogin) {
            // 已有舊登入態：先登出（getLogoutApi 內部會自行導頁重置），成功後才寫入新 token，避免新舊憑證疊加
            await getLogoutApi(() => {
                localUser.setToken(tokenKey);
            });
        } else {
            // 尚無登入態：直接寫入 token 並導向登入頁，交給 LoginPage / LiffLoginPage 接手後續流程
            localUser.setToken(tokenKey);
            history.push(nextPath);
        }

    };

    // 用 layout effect（而非一般 effect）搶在畫面繪製前完成 token 交接，避免使用者看到中間態
    useLayoutEffect(
        () => {
            const key = query.get('t');
            const splitPathname = rootPath.split('/');
            const matched = splitPathname.length > 1 && splitPathname[1] === 'auth' && key !== '';
            if (matched) {
                if (!didAuthRef.current) {
                    // StrictMode 下 effect 會 double-invoke；此 ref 確保 token 只被消費一次
                    didAuthRef.current = true;
                    resetToken(key, LOGIN_ROOT_ROUTER);
                }
            }
        },
        // eslint-disable-next-line
        [rootPath],
    );

    return null;
};

export default AuthPage;